<div class="scene-input-container">
  <div class="section">
    <div class="section-header">
      <label class="label">Text</label>
    </div>
    <div *ngIf="textValues.length === 0" class="empty-hint">
      No text added. Click + to add text.
    </div>
    <div *ngFor="let textValue of textValues; let i = index" class="text-item">
      <textarea
        #textArea
        class="text-area"
        [value]="textValue"
        (change)="onTextChange($event, i)"
        (keydown.enter)="onTextEnter($event, i)"
        (input)="autoResize($event)"
        [placeholder]="'Enter text ' + (i + 1) + '...'"
        rows="1"
      ></textarea>
      <div
        class="remove-btn-text"
        title="Delete scene"
        (click)="removeTextInput(i)"
      >
        <nw-icon type="close" [size]="12" color="black"></nw-icon>
      </div>
    </div>
    <div class="text-item" *ngIf="pendingText">
      <div class="pending-text">
        <textarea
          #pendingTextArea
          class="text-area"
          placeholder="Enter text..."
          rows="1"
          (input)="autoResize($event)"
          (blur)="onPendingTextChange($event)"
          (keydown.enter)="onPendingTextEnter($event)"
        ></textarea>
      </div>
    </div>
    <div class="text-add-button" (click)="addNewText()">+</div>
  </div>

  <div class="section">
    <div class="section-header">
      <label class="label">Images</label>
    </div>
    <div class="image-thumbnails">
      <div
        *ngFor="let imageId of sceneImageIds; let i = index"
        class="thumbnail"
      >
        <img [src]="getImageThumbnailUrl(imageId)" alt="Scene image" />
        <button
          class="remove-btn"
          (click)="removeImage(i)"
          title="Remove image"
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="add-button" (click)="openImageUploadModal()">+</div>
    </div>

    <!-- 
    <button class="add-btn" (click)="openImageUploadModal()">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
    </button> 
    -->
  </div>

  <div class="section">
    <div class="section-header">
      <label class="label">Videos</label>
    </div>
    <div class="video-thumbnails">
      <div
        *ngFor="let videoId of videoInstanceIds; let i = index"
        class="thumbnail"
        (click)="onVideoClick(videoId)"
      >
        <img [src]="getVideoThumbnailUrl(videoId)" />
        <button
          class="remove-btn"
          (click)="removeVideo(i)"
          title="Remove video"
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="add-button" (click)="openVideoUploadModal()">+</div>
    </div>
    <!--
    <div *ngIf="sceneVideoIds.length === 0" class="empty-hint">
      No videos selected
    </div> 
    -->
  </div>
</div>

<nw-media-upload-modal
  *ngIf="showMediaUploadModal"
  [type]="mediaUploadType"
  [selectedMediaIds]="
    mediaUploadType === 'image' ? sceneImageIds : videoInstanceIds
  "
  (cancel)="closeMediaUploadModal()"
  (submit)="onMediaSubmit($event)"
></nw-media-upload-modal>

<nw-media-preview-modal
  [videoShape]="selectedVideoShape"
  (close)="onVideoCancelled()"
  (videoSaved)="onVideoSaved($event)"
></nw-media-preview-modal>
